import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, requiredRole = null, allowedRoles = null }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const getDashboardPath = () => {
    if (user.role === 'super_admin') return '/super-admin';
    if (user.role === 'owner') return '/owner';
    if (user.role === 'employee') return user.employeeType === 'accountant' ? '/employee' : '/tasks';
    return '/employee';
  };

  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to={getDashboardPath()} replace />;
  }

  if (allowedRoles && Array.isArray(allowedRoles) && !allowedRoles.includes(user.role)) {
    return <Navigate to={getDashboardPath()} replace />;
  }

  return children;
};

export default PrivateRoute;
